import React from 'react';
import useLocalization from 'localization';
import useTheme from 'branding/theme';
const Label = ({ htmlFor, children, required = false, disabled = false, inverted = false, centered = false, role = 'label', styles }) => {
    const { t } = useLocalization();
    const { typography, colors } = useTheme();
    const Tag = role;
    const mergedStyles = {
        ...typography.eyebrow,
        ...(inverted && typography.inverted),
        ...(disabled && { color: colors.neutrals.borderBeta }),
        ...(centered && { textAlign: 'center' }),
        ...styles
    };
    return (React.createElement(Tag, { ...(role === 'label' && { htmlFor }), style: mergedStyles },
        typeof children === 'string' ? t(String(children)) : children,
        required && '*'));
};
export default Label;
//# sourceMappingURL=index.js.map